import { Controller } from "@hotwired/stimulus"
import { TagChipsMixin } from "../lib/tag_chips_mixin"

// Email-address tag input. The whole interaction (Enter/comma commits a chip,
// × removes one, blur commits pending text, Backspace on an empty field removes
// the last chip, hidden field kept in sync) lives in TagChipsMixin — shared with
// blog_tag_chips_controller.js. This controller only supplies the email
// specifics: the `gl-email-tags` chip markup and a newline-joined hidden value,
// which the server (Crm::EmailAccount.normalize_address_list) splits,
// normalizes, de-duplicates and validates on save. No client-side validation
// here on purpose — the model is the authority on what a usable address is.
export default class extends TagChipsMixin(Controller) {
  static targets = ["hidden", "input"]

  get chipNamespace() {
    return "gl-email-tags"
  }

  get valueSeparator() {
    return "\n"
  }
}
